<lcp-header></lcp-header>

<div class="main-content-container padding-bottom-0">
  <ng-container *ngIf="fields">
    <section class="lcp-section">
      <div class="lcp-section-content">
        <div class="display-flex">
          <h1 *ngIf="fields['title']" class="section-title margin-top-20 margin-bottom-80 flex-50-not-sm">
            {{ fields['title'] }}
          </h1>
        </div>
      </div>
    </section>

    <section *ngFor="let section of fields['sections']"
      [ngClass]="['lcp-section', 'lcp-' + section.fields['slug']]"
      [class.is-inverted]="section.fields['inverted']">

      <div class="lcp-section-content">
        <h2 *ngIf="section.fields['title']" class="section-title">
          {{ section.fields['title'] }}
        </h2>
      
        <div class="section-main-content">
          <ng-container *ngIf="section.fields['slug'] == 'services-services'">
            <ng-content *ngTemplateOutlet="servicesServicesTemplate; context:{ section: section }"></ng-content>
          </ng-container>
  
          <ng-container *ngIf="section.fields['slug'] == 'services-bottom'">
            <ng-content *ngTemplateOutlet="servicesBottomSection; context:{ section: section }"></ng-content>
          </ng-container>
        </div>
      </div>
    </section>
  </ng-container>
</div> 

<ng-template #servicesServicesTemplate let-section="section">
  <div class="services-services-container">
    <div class="service-divider"></div>
    <div class="services-service-container" *ngFor="let block of section.fields['items']; index as i">

      <!-- <lcp-rich-text *ngIf="block.fields['slug'] == 'about-services-nav'" 
        class="lcp-subheading about-services-nav"
        [class.is-inverted]="section.fields['inverted']"
        [document]="block.fields['body']">
      </lcp-rich-text> -->

      <div class="service-wrapper-mobile display-block-only-sm">
        <ng-content *ngTemplateOutlet="servicesServiceMobile; context:{ block: block, index: i }"></ng-content>
      </div>

      <div class="service-wrapper-desktop display-none-sm">
        <ng-content *ngTemplateOutlet="servicesServiceDesktop; context:{ block: block, index: i }"></ng-content>
      </div>

      <div class="services-service-image-container">
        <div class="services-service-image" *ngIf="block.fields['media']">
          <img [src]="lcpHelper.urlFromMedia(block.fields['media'][0])">
        </div>
      </div>
      <div class="service-divider"></div>
    </div>
  </div>
</ng-template>


<ng-template #servicesServiceDesktop let-block="block" let-index="index">
  <div [ngClass]="['services-service', 'services-service-' + index]" 
    [id]="'services-service-desktop-' + index"
    (mouseover)="handleHoverService({ block: block, index: index })"
    (mouseleave)="handleBlurService({ index: index })"
    (click)="handleSelectService(block)"
    (keydown.enter)="handleSelectService(block)"
    tabindex="0">

    <!-- (focus)="handleHoverService({ block: block, index: index })" -->

    <div class="services-service-flex">
      <div class="services-service-flex-left">
        <h4 class="services-service-title">{{ block.fields['title'] }}</h4>
        <div class="services-service-description-container">
          <!-- <div class="services-service-cursor"></div> -->
          <div class="services-service-cursor-empty"></div>

          <div class="services-service-description">
              <span class="services-service-description-text"></span>
              <span class="services-service-cursor-container">
                <div class="services-service-cursor"></div>
              </span>
          </div>


          <div class="services-service-description-placeholder">{{ lcpHelper.richTextToString(block.fields['body']) + " learn more" }}</div>

          <!-- <lcp-rich-text
            class="services-service-description-rich-text opacity-0"
            [document]="block.fields['body']">
          </lcp-rich-text> -->
        </div>
      </div>
      
      <div class="services-service-flex-right">
        <!-- <div class="services-service-image">
          <img [src]="lcpHelper.urlFromMedia(block.fields['media'][0])">
        </div> -->
      </div>
    </div>
  </div>
</ng-template>

<ng-template #servicesServiceMobile let-block="block" let-service="service">
  <div class="services-service">

    <div class="services-service-flex">
      <div class="services-service-flex-left">
        <h4 class="services-service-title">{{ block.fields['title'] }}</h4>
        <div class="services-service-description-container">
          <div class="services-service-cursor-empty"></div>
          <div class="services-service-description">
            <span class="services-service-description-text"></span>
            <span class="services-service-cursor-container">
                <div class="services-service-cursor"></div>
              </span>
            <!-- <lcp-rich-text
              class="services-service-description"
              [document]="block.fields['body']">
            </lcp-rich-text> -->
          </div>
          <div class="services-service-description-placeholder">{{ lcpHelper.richTextToString(block.fields['body']) + " learn more" }}</div>
        </div>
      </div>
      
      <div class="services-service-flex-right">
        <div class="services-service-image">
          <img [src]="lcpHelper.urlFromMedia(block.fields['media'][0])">
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #servicesBottomSection let-section="section">
  <!-- <div class="about-story-section">
    <div class="about-story-container" *ngFor="let story of section.fields['items']">
      <div class="lcp-subheading story"
        [class.is-inverted]="section.fields['inverted']">
        <p>
          {{ story.fields['title'] }}
        </p>
      </div>
    </div>
  </div> -->
</ng-template>